import { useEmployeeQuery } from '@alice-financial/alice-sdk'

/**
 * checks whether the application is running in demo-mode for current user.
 * Note: Production will always return `false`
 * using parallel logic to the BE definition of `is_interactive_demo`	 * Note: Production will always return `false`
 *
 * @see https://github.com/alice-financial/alice/blob/32b9494c2211d57c9ce05cb7c7d9a62243467b1c/app/services/fake/interactive_demo_service.rb#L18-L24
 */
export const useIsDemoUser = () => {
  const { data: employeeData } = useEmployeeQuery()
  const employee = employeeData?.employee
  // Vite provides import.meta.env.PROD boolean for production check
  if (import.meta.env.PROD) return false

  return Boolean(employee?.employer.name?.toLowerCase().includes('interactive'))
}
